import File from './file';
import MinimapIcon from './minimapicon';

export default {
  File,
  MinimapIcon,
};
